"use client";
import React, { useState, useRef, useEffect } from "react";
import Script from "next/script";
import styles from "./Header.module.css";
import axios from "axios";
import CryptoJS from "crypto-js";
import { truncateText } from "../../utils/helpers";

import {
  getUserData,
  getUserAuthData,
} from "../../hooks/HelperFunctions";

import DcLogo from "../../assets/imgs/takbir-lms-learning-management-system-muslim-logo-4x.png";
import ShopingBadge from "../../assets/imgs/shopping_bag_blue.svg";
import Button from "@mui/material/Button";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import Buttons from "../Button/Button";
import ModalThree from "../Modals/ModalThree";
import SignUp from "../../pages/authentication/SignUp";
import SignIn from "../../pages/authentication/SignIn";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import userIcon from "../../assets/imgs/instructor-img-1.png";

// Menu Icons
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import QuestionAnswerRoundedIcon from "@mui/icons-material/QuestionAnswerRounded";
import InsertInvitationRoundedIcon from "@mui/icons-material/InsertInvitationRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import LogoutIcon from "@mui/icons-material/Logout";

import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";

import AlrtMessageFullWidth from "../AlrtMessage/AlrtMessageFullWidth";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import SearchIcon from "@mui/icons-material/Search";
import SearchBox from "../SearchBox/SearchBox";
import Welcome from "../../pages/authentication/Welcome";
import CustomDrawer from "../CustomDrawer/CustomDrawer";
import WelcomeSection from "../AuthSections/Welcome";
import Password from "../AuthSections/Password";

import Image from "next/image";

// import { useRouter } from "next/router";

import SideDrawer from "../../pages/Payments/compononents/SideDrawer/SideDrawer";
import ShoppingCart from "../../pages/Payments/forms/ShoppingCart";
import {
  ShoppingCartProvider,
  useShoppingCart,
} from "../../contexts/CartContext";
import Link from "next/link";

import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import ForgotPassword from "../AuthSections/ForgotPassword";
import ConfirmPassword from "../AuthSections/ConfirmPassword";
import ConfirmationOTP from "../AuthSections/ConfirmationOTP";
import Finish from "../AuthSections/Finish";
import Profile from "../AuthSections/Profile";
import CreatePassword from "../AuthSections/CreatePassword";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  studentAccessibleUrls,
  teacherAccessibleUrls,
} from "../../hooks/TeacherStudentAccessibleUrls";

import { apiRequest } from "../../utils/axiosInstance";
import { AutoAwesomeSharp } from "@mui/icons-material";
import SimpleBackdrop from "../Backdrop/SimpleBackdrop";
import { useDispatch, useSelector } from "react-redux";
import { setActiveOrgId, setPermittedModules } from "../../redux/orgSlice";
import { setActiveSelectedCourseIndex } from "../../redux/dashboardSlice";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import RunningCourseAlertMessage from "../../components/AlrtMessage/RunningCourseAlertMessage";
import NotificationComponent from "../Notification/Notification";
// import { setActiveOrgId } from "../../redux/store";
import { messaging } from "../../lib/firebase";
import { getToken, onMessage } from "firebase/messaging";
import { jwtDecode } from "jwt-decode";
import { setActiveCurrency } from "../../redux/currencySlice";

function Header(props) {
  const {
    subdomain,
    updateCart,
    setUpdateCart,
    openSignUpModel,
    setOpenSignUpModel,
    enrollNowHandler,
    enrollNowTrackTermHandler,
  } = props;

  const dispatch = useDispatch();
  const activeOrgId = useSelector((state) => state.org.activeOrgId);
  const userBasicInfo = useSelector((state) => state.userBasicInfo);
  
  const envType = process.env.NEXT_PUBLIC_PROJECT_ENV;
  const [show, setShow] = useState(false);

  const [cartCourse, setCartCourse] = useState([]);
  const [countries, setCountries] = useState([]);
  const [timezones, setTimezones] = useState([]);
  const [highestEducations, setHighestEducations] = useState([]);
  const [profileCompleted, setProfileCompleted] = useState(true);

  const [userAuthenticated, setUserAuthenticated] = useState(false);
  const [userVerified, setUserVerified] = useState(false);
  const [userData, setUserData] = useState([]);

  const [alertText, setAlertText] = useState(
    "Check your email so you can quickly complete your verification"
  );
  const [alertBtnLabel, setAlertBtnLabel] = useState("Resend email");

  const [searchBoxText, setSearchBoxText] = useState("");
  const [signInWith, setSignInWith] = useState("email");
  const [signUpWith, setSignUpWith] = useState("email");
  const [alreadyEnrolledCourses, setAlreadyEnrolledCourses] = useState([]);
  const [tacksToShopping, setTacksToShopping] = useState([]);
  const [ipLocationInfo, setIpLocationInfo] = useState(null);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);

  const router = useRouter();

  // Use useSearchParams for query parameters
  const searchParams = useSearchParams();

  // Extract query parameters
  const active_modal = searchParams.get("active_modal");
  const invite_token = searchParams.get("invite_token");
  const invited_as_teacher = searchParams.get("invited_as_teacher");
  const organization_invitation = searchParams.get("organization_invitation");
  const from = searchParams.get("from");
  const openSignInDrawer = searchParams.get("openSignInDrawer");
  const redirect_to_admin = searchParams.get("redirect_to_admin");
  const new_teaching_info_token = searchParams.get("new_teaching_info_token");

  // Use usePathname to get the current path
  const currentPath = usePathname();

  // Split the path and get the second segment
  const pathSegment = currentPath?.split("/")[1];

  const teacherSpecialUrl = [
    "tracks",
    "roles-permissions",
    "users",
    "media-library-table-view",
    "team-listing",
    "student-details",
    "team-details",
    "create-new-teaching-account",
  ];

  // Check if the current path matches any of the accessible URLs
  const isReservedUrlsForTeacherStudent =
    teacherAccessibleUrls().includes(pathSegment) ||
    studentAccessibleUrls().includes(pathSegment);

  // console.log(active_modal, 345, invite_token);
  const { cartItems, setCartItems, setCartItemsCoupons } = useShoppingCart();
  const [cartTrack, setCartTrack] = useState([]);

  // * == auth states starts == * //
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [phoneFormatted, setPhoneFormatted] = useState("");
  const [authState, setAuthState] = useState(false);
  const [authSteps, setAuthSteps] = useState(0);
  const [welcomeResetKey, setWelcomeResetKey] = useState(0);
  const [drawerTitle, setDrawerTitle] = useState("");
  const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
  const [changingToken, setChangingToken] = useState("");
  const [backArrowIcon, setBackArrowIcon] = useState(false);
  const [previousSteps, setPreviousSteps] = useState([]);
  const [invitedMember, setInvitedMember] = useState(null);
  const [freshNewAccountMember, setFreshNewAccountMember] = useState(null);
  const [activeUserType, setActiveUserType] = useState(null);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [showButton, setShowButton] = useState(false);

  /**
   * close backdrop
   */
  const handleCloseBackdrop = () => {
    setOpenBackdrop(false);
  };

  const prcoessActiveUserTypeAndOrgId = () => {
    const orgId = localStorage.getItem("orgId");
    if (!orgId || !(orgId > 0)) {
      setActiveUserType("student");
    }
    if (orgId && orgId > 0) {
      setActiveUserType("teacher");
      dispatch(setActiveOrgId(orgId));
    }
  };

  const processExpireCoursesAndOrgRelatedToReferral = () => {
    // Function to be executed every 5 seconds
    const intervalId = setInterval(() => {
      // Call this function to remove expired courses and org related to referral
      removeExpiredCoursesTracksReferral();
      removeExpiredOrganizationsReferral();
    }, 5000); // 5000ms = 5 seconds

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  };

  const getAlreadyEnrolledCoursesAndNecessaryData = () => {
    const path = window.location.pathname;

    // code for retriving already enrolled courses
    const apiBaseUrl =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_API_URL_PROD
        : process.env.NEXT_PUBLIC_API_URL_DEV;

    const userData = getUserData();
    const userId = userData.id;

    const shouldSkipApiCalls = path === "/" || path.startsWith("/t/");

    if (userId) {
      axios
        .get(`${apiBaseUrl}/getAlreadyEnrolledCourses?userId=${userId}`)
        .then((result) => {
          setAlreadyEnrolledCourses(result?.data?.body);
          localStorage.setItem(
            "alreadyEnrolledCourses",
            JSON.stringify(result?.data?.body)
          );
        })
        .catch((err) => {
          console.log(err);
        });

      if (!shouldSkipApiCalls) {
        axios
          .get(`${apiBaseUrl}/getCountries`)
          .then((result) => {
            setCountries(result?.data?.body);
          })
          .catch((err) => {
            console.log(err);
          });

        axios
          .get(`${apiBaseUrl}/getTimezones`)
          .then((result) => {
            setTimezones(result?.data?.body);
          })
          .catch((err) => {
            console.log(err);
          });

        axios
          .get(`${apiBaseUrl}/getHighestEducations`)
          .then((result) => {
            setHighestEducations(result?.data?.body);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }

    let invitedMember = localStorage.getItem("invitedMember");
    if (invitedMember) {
      setInvitedMember(JSON.parse(invitedMember));
    } else {
      setInvitedMember(null);
    }

    let newTeachingAccount = localStorage.getItem("newTeachingAccount");
    if (newTeachingAccount) {
      setFreshNewAccountMember(JSON.parse(newTeachingAccount));
    } else {
      setFreshNewAccountMember(null);
    }
  };
  const processCheckTokenValidationAndProfileCompleted = () => {
    const userToken = localStorage.getItem("userToken");
    const profile_completed = localStorage.getItem("profile_completed");
    if (userToken) {
      const baseUrl =
        process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
          ? process.env.NEXT_PUBLIC_API_URL_PROD
          : process.env.NEXT_PUBLIC_API_URL_DEV;
      axios.defaults.headers.common["Authorization"] = `Bearer ${userToken}`;

      // check user token is valid or not, if not then auto sign out
      axios
        .get(`${baseUrl}/checkTokenValidation`)
        .then((result) => {
          console.log(result.data.body);
        })
        .catch((err) => {
          console.log(err?.response?.data?.message);
          if (err?.response?.data?.message == "Unauthenticated.") {
            // clear all local data
            localStorage.clear();
            router.refresh();
          }
        });

      const localUserVerified = localStorage.getItem("userVerified");
      if (localUserVerified == "true") {
        const userData = getUserData();
        axios
          .get(
            `${baseUrl}/studentPortal/checkProfileCompleted?userId=${userData.id}`
          )
          .then((result) => {
            console.log(result.data.profileCompleted);
            setProfileCompleted(result.data.profileCompleted);
          })
          .catch((err) => {
            console.log(err?.response?.data?.message);
          });
      }
    }
    if (profile_completed && profile_completed == "true") {
      setAuthSteps(0);
      setAuthState(false);

      if (typeof setOpenSignUpModel === "function") {
        setOpenSignUpModel(false); // Call the function
      }
    } else if (profile_completed && profile_completed == "false") {
      // setAuthSteps(3);
      // setAuthState(true);
      router.push("/onboarding");
    } else {
      setAuthSteps(0);
      setAuthState(false);

      if (typeof setOpenSignUpModel === "function") {
        setOpenSignUpModel(false); // Call the function
      }
    }
  };

  useEffect(() => {
    const userAuthenticated = localStorage.getItem("userAuthenticated");

    prcoessActiveUserTypeAndOrgId();
    processExpireCoursesAndOrgRelatedToReferral();
    getAlreadyEnrolledCoursesAndNecessaryData();
    processCheckTokenValidationAndProfileCompleted();
    processScroll();
    processIpCountryInfo();
    
    if (typeof window !== "undefined") {
      const isTeachingPage = window.location.pathname.includes("/t/");
      setShowButton(!isTeachingPage);
    }
    if(userAuthenticated == 'true') {
      const cleanup = initiateJWTTokenIfLoggedIn();
      console.log(userAuthenticated, 'userAuthenticated')
      return cleanup; 
    }
  }, []);

  useEffect(() => {
    // Listen for messages from service worker
    const handleServiceWorkerMessage = (event) => {
      // console.log('Received message from service worker:', event.data);
      if (event.data && event.data.type === "SHOW_ALERT") {
        // Display the notification message in an alert
        // console.log('Notification received:', event.data.title, event.data.body);
        // alert(`${event.data.body}`);
        setShowNotification(true);
        setNotificationMessage(`${event.data.body}`);
      }
    };

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener(
        "message",
        handleServiceWorkerMessage
      );
    }

    return () => {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.removeEventListener(
          "message",
          handleServiceWorkerMessage
        );
      }
    };
  }, []);

  // ...existing code...
  useEffect(() => {
    const requestNotificationPermission = async () => {
      try {
        const permission = await Notification.requestPermission();

        if (permission === "granted") {
          console.log("Notification permission granted.");

          // For FCM v1, you don't need vapidKey
          const token = await getToken(messaging);

          if (token) {
            // console.log('FCM Token:', token);
            // Send token to your server
            const apiBaseUrl =
              process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
                ? process.env.NEXT_PUBLIC_API_URL_PROD
                : process.env.NEXT_PUBLIC_API_URL_DEV;

            const userAuthenticated = localStorage.getItem("userAuthenticated");
            console.log("userAuthenticated", userAuthenticated);

            if (userAuthenticated === "true") {
              const userId = getUserData().id;

              // console.log("userId", userId);

              const data = await apiRequest("/save-fcm-token", "POST", {
                token,
                userId,
              });
              // console.log("FCM Token saved successfully:", data);
            }
          }
        } else {
          console.log("Notification permission denied.");
        }
      } catch (error) {
        console.error("Error requesting notification permission:", error);
      }
    };

    // Handle foreground messages
    if (
      typeof window !== "undefined" &&
      "serviceWorker" in navigator &&
      messaging
    ) {
      onMessage(messaging, (payload) => {
        // console.log('Message received in foreground:', payload);
        // showSnackbarMessage("info", payload.notification.title);
      });

      requestNotificationPermission();
    }
  }, []);
  // ...existing code...

  const initiateJWTTokenIfLoggedIn = () => {
    console.log('this is something 1')
    const checkToken = async () => {
      const exp = localStorage.getItem("token_exp");
      if (!exp) return;
      
      const expiresIn = exp - Date.now();
      
      if (expiresIn < 30 * 60 * 1000) {
        try {

          let postData = {
            jwt_token : localStorage.getItem("jwtToken")
          }
          const data = await apiRequest(
            "/jwt_refresh",
            "POST",
            postData
          );
    
          if (!data.error) {
            localStorage.setItem("jwtToken", data?.data?.jwt_token);
            
            try {
              const decoded = jwtDecode(data?.data?.jwt_token);
              localStorage.setItem("token_exp", decoded.exp * 1000);
            } catch (e) {
              console.error("Invalid decoded token", e);
            }
          } else {
            // logout
          }
        } catch (error) {
          console.error(error);
        }

      }
    };
  
    // Run immediately
    checkToken();
  
    // Check every 1 minute
    const interval = setInterval(checkToken, 60 * 1000);
  
    return () => clearInterval(interval);
  };
  
  const processIpCountryInfo = () => {
    fetch(
      `https://ipinfo.io/json?token=${process.env.NEXT_PUBLIC_IPINFO_TOKEN}`
    ) // Replace with your token
      .then((response) => response.json())
      .then((data) => {
        setIpLocationInfo({
          ip: data.ip,
          city: data.city,
          region: data.region,
          country: data.country,
          timezone: data.timezone,
        });
        localStorage.setItem(
          "ipLocationInfo",
          JSON.stringify({
            ip: data.ip,
            city: data.city,
            region: data.region,
            country: data.country,
            timezone: data.timezone,
          })
        );
      })
      .catch((error) => {
        console.error("Error fetching location info:", error);
      });
  };

  const [expireCounter, setExpireCounter] = useState(0);

  const removeExpiredCoursesTracksReferral = () => {
    const courses =
      JSON.parse(localStorage.getItem("coursesRefferedByOrg")) || [];

    const tracks =
      JSON.parse(localStorage.getItem("tracksRefferedByOrg")) || [];

    const currentTime = new Date().getTime();

    const updatedCourses = courses.filter((course) => {
      const [, timestamp] = course.split("_");

      return currentTime <= parseInt(timestamp);
    });

    const updatedTracks = tracks.filter((track) => {
      const [, timestamp] = track.split("_");

      return currentTime <= parseInt(timestamp);
    });

    localStorage.setItem(
      "coursesRefferedByOrg",
      JSON.stringify(updatedCourses)
    );

    localStorage.setItem("tracksRefferedByOrg", JSON.stringify(updatedTracks));
  };

  const removeExpiredOrganizationsReferral = () => {
    const organizations =
      JSON.parse(localStorage.getItem("organizationsReferred")) || [];

    const currentTime = new Date().getTime();

    const updatedOrganizations = organizations.filter((organization) => {
      const [, timestamp] = organization.split("_");

      return currentTime <= parseInt(timestamp);
    });

    localStorage.setItem(
      "organizationsReferred",
      JSON.stringify(updatedOrganizations)
    );
  };

  useEffect(() => {
    if (activeUserType == "teacher") {
      getAllPermissionOperationKeys();
      getUserPermissionOperationKeys();
    }
  }, [activeUserType]);

  const getAllPermissionOperationKeys = async () => {
    setOpenBackdrop(true);
    try {
      const data = await apiRequest(
        `/getAllPermissionOperationKeys`,
        "GET",
        null
      );

      if (!data?.error) {
        localStorage.setItem(
          "allPermissionOperationKeys",
          JSON.stringify(data?.data)
        );
        setOpenBackdrop(false);
      }
    } catch (error) {
      console.log(error);
      setOpenBackdrop(false);
    }
  };

  const accessRevoked = () => {
    let teachingAccountList =
      JSON.parse(localStorage.getItem("teachingAccounts")) || [];
    let organizationId = localStorage.getItem("orgId");

    let foundOrg = teachingAccountList.find(
      (singleOrg) => singleOrg.orgId == organizationId
    );
    let accessRevoked = false;

    if(foundOrg && foundOrg.status == "inactive"){
      accessRevoked = true
    }
    return accessRevoked;
  };
  const getUserPermissionOperationKeys = async () => {
    let selectedTeachingAccount = localStorage.getItem(
      "selectedTeachingAccount"
    )
      ? JSON.parse(localStorage.getItem("selectedTeachingAccount"))
      : {};
    const orgId = localStorage.getItem("orgId");
    let postData = {
      orgId,
    };
    setOpenBackdrop(true);
    try {
      const data = await apiRequest(
        `/orgPortal/getUserPermissionOperationKeys`,
        "POST",
        postData
      );

      if (!data?.error) {
        localStorage.setItem(
          "userPermissionOperationKeys",
          JSON.stringify(data?.data)
        );
        dispatch(setPermittedModules(data?.permittedModules));
        localStorage.setItem(
          "userPermittedModules",
          JSON.stringify(data?.permittedModules)
        );

        let isAccessRevoked = accessRevoked()
        
        const hasRole =
        selectedTeachingAccount?.role === "Owner" ||
        data?.permittedModules?.length > 0;
        if (!hasRole || isAccessRevoked) {
          router.push("/no-role");
        }
        setOpenBackdrop(false);
      }
    } catch (error) {
      const hasRole = selectedTeachingAccount?.role === "Owner";
      if (!hasRole) {
        router.push("/no-role");
      }
      dispatch(setPermittedModules([]));
      localStorage.setItem("userPermissionOperationKeys", JSON.stringify([]));
      localStorage.setItem("userPermittedModules", JSON.stringify([]));
      setOpenBackdrop(false);
    }
  };

  if(activeOrgId > 0){
    let isAccessRevoked = accessRevoked()
    if (isAccessRevoked) {
      router.push("/no-role");
    }
  }

  useEffect(() => {
    switch (authSteps) {
      case 0:
        setDrawerTitle("Log in or sign up");
        setBackArrowIcon(false);
        break;
      case 1:
        setDrawerTitle("Log in");
        setBackArrowIcon(true);
        break;
      case 2:
        setDrawerTitle("Confirm account");
        setBackArrowIcon(true);
        break;
      case 3:
        setDrawerTitle("Complete Profile");
        setBackArrowIcon(false);
        break;
      case 4:
        setDrawerTitle("Setup new password");
        setBackArrowIcon(true);
        break;
      case 5:
        setDrawerTitle("Forgot password?");
        setBackArrowIcon(true);
        break;
      case 6:
        setDrawerTitle("Create account");
        setBackArrowIcon(true);
        break;
      default:
        break;
    }

    const stepsWithBackArrow = [1, 2, 4, 5, 6];
    setBackArrowIcon(stepsWithBackArrow.includes(authSteps));

    // Push to previous steps stack only if not returning from handleBackArrowFn
    if (stepsWithBackArrow.includes(authSteps)) {
      setPreviousSteps((prev) => [...prev, authSteps]);
    }
  }, [authSteps]);

  // ! == Back arrow function to navigate to the previous step
  const handleBackArrowFn = () => {
    if (backArrowIcon && previousSteps.length > 0) {
      let newPreviousSteps = [...previousSteps];
      let lastStep = newPreviousSteps.pop();
      if (lastStep == authSteps) {
        lastStep = newPreviousSteps.pop();
      }

      setAuthSteps(lastStep || 0);
      setPreviousSteps([...newPreviousSteps]);
    } else {
      setAuthSteps(0); // Default
    }
  };

  // * ==  auth states end  == * //

  useEffect(() => {
    if (forgotPasswordMode && authSteps == 2) {
      setDrawerTitle("Enter confirmation code");
    }
    if (authSteps == 2 && signInWith == "phone") {
      setDrawerTitle("Confirm your number");
    }
  }, [forgotPasswordMode, authSteps, signInWith]);

  let orgLogo = process.env.NEXT_PUBLIC_ORG_LOGO;
  orgLogo = orgLogo?.replace("sub-domain", subdomain);

  const searchText = searchParams.get("q");

  useEffect(() => {
    if (searchText) {
      setSearchBoxText(searchText);
    }
  }, [searchText]);

  useEffect(() => {
    if (alreadyEnrolledCourses?.length > 0) {
      filterPart();
    }
  }, [alreadyEnrolledCourses]);
  const filterPart = () => {
    if (alreadyEnrolledCourses) {
      const enrolledCourseIds = alreadyEnrolledCourses?.map(
        (course) => course?.courseId
      );
      const filteredCartItems = cartItems.filter((cartItem) => {
        if (cartItem.courseId) {
          return !enrolledCourseIds.includes(cartItem.courseId);
        }
        if (cartItem.courses) {
          return !cartItem.courses.some((course) =>
            enrolledCourseIds.includes(course.courseId)
          );
        }
        return true;
      });
      const onlyCourses = filteredCartItems?.filter(
        (course) => course.courseId
      );
      setCartItems(filteredCartItems);
      localStorage.setItem(
        "cartPaymentInfo",
        JSON.stringify(filteredCartItems)
      );
      localStorage.setItem("selectedCourses", JSON.stringify(onlyCourses));
    }
  };

  useEffect(() => {
    setUserData(JSON.parse(localStorage.getItem("userData")));
    setUserAuthenticated(localStorage.getItem("userAuthenticated"));
    setUserVerified(localStorage.getItem("userVerified"));
  }, [userAuthenticated]);

  useEffect(() => {
    setUserData(JSON.parse(localStorage.getItem("userData")));
  },[userBasicInfo])

  useEffect(() => {
    if (updateCart == true) {
      const localCartCourse = JSON.parse(
        localStorage.getItem("selectedCourses")
      );
      setCartCourse(localCartCourse);
      setUpdateCart(false);
    }
  }, [cartCourse, updateCart]);

  // === Sign Up == *//
  const [openSignUp, setOpenSignUp] = React.useState(false);
  const handleOpenSignUp = () => setOpenSignUp(true);
  const handleCloseSignUp = () => {
    setOpenSignUp(false);
    setOpenSignUpModel(false);
  };
  // === Sign Up == *//

  // === Sign In == *//
  const [openSignIn, setOpenSignIn] = React.useState(false);
  const handleOpenSignIn = () => setOpenSignIn(true);
  const handleCloseSignIn = () => setOpenSignIn(false);
  // === Sign In == *//

  const logoutHandler = async () => {
    const baseUrl =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_API_URL_PROD
        : process.env.NEXT_PUBLIC_API_URL_DEV;

    const userToken = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = `Bearer ${userToken}`;
    try {
      const result = await axios.get(`${baseUrl}/logout`);
      if (result.data.status) {
        setUserAuthenticated(false);
        let lastTimeLoggedInWith = localStorage.getItem("lastTimeLoggedInWith");
        setCartItemsCoupons([]);
        localStorage.clear();
        localStorage.setItem("lastTimeLoggedInWith", lastTimeLoggedInWith);
        localStorage.setItem("showCeoModal", true);
        router.push(window.location.origin);
      } else {
        console.log("Logout Error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  //========================= checking user isn't sign or not ================================//

  const checkedUserSignStatus = () => {
    const userInfo = JSON.parse(localStorage.getItem("userData"));
    if (!userInfo) {
      return false;
    }
    // console.log(userInfo?.email, 345);
    let data = {
      email: userInfo?.email,
      invite_token: invite_token,
    };
    const baseUrl =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_API_URL_PROD
        : process.env.NEXT_PUBLIC_API_URL_DEV;

    axios
      .post(`${baseUrl}/addInstructorIfSignedIn`, data)
      .then((result) => {
        console.log(result, 345);
        if (!result.data.error) {
          handleMyCourses();
        } else {
          console.log("Logout Error");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [activeModalForSignUp, setActiveModalForSignUp] = useState("");

  useEffect(() => {
    if (openSignInDrawer && !userAuthenticated) {
      setSignInWith("email");
      setAuthState(true);
    }
  }, [openSignInDrawer]);

  useEffect(() => {
    if ((authState || openSignUpModel) && authSteps === 0) {
      setSignInWith("email");
    }
  }, [authState, openSignUpModel, authSteps]);

  useEffect(() => {
    let userDataInfo = getUserData();
    console.log(
      redirect_to_admin,
      "redirect_to_admin",
      active_modal,
      "active_modal"
    );
    let isAuthenticated = localStorage.getItem("userAuthenticated");

    if (redirect_to_admin == "true" && isAuthenticated) {
      if (new_teaching_info_token) {
        let newUserDataObject = {};
        atob(new_teaching_info_token)
          .split("&")
          .map((data) => {
            let dataWithKeyVal = data.split("=");
            newUserDataObject[dataWithKeyVal[0]] = dataWithKeyVal[1];
          });

        if (newUserDataObject?.orgId != "") {
          localStorage.setItem("orgId", newUserDataObject?.orgId);

          dispatch(setActiveOrgId(newUserDataObject?.orgId));
          dispatch(setActiveSelectedCourseIndex(null));

          router.push("/teaching-home");
        } else {
          if (newUserDataObject?.email == userDataInfo?.email) {
            handleMyCourses();
          }
        }
      }
    }

    if (active_modal === "sign_in") {
      if (invite_token) {
        checkedUserSignStatus();
      }
      if (isAuthenticated) {
        setAuthSteps(0);
        setAuthState(false);
      } else {
        setAuthState(true);
        setSignInWith("email");
      }
    } else if (active_modal === "sign_up") {
      if (isAuthenticated) {
        setAuthSteps(0);
        setAuthState(false);
      } else {
        setAuthState(true);
        setSignInWith("email");

        if (new_teaching_info_token && new_teaching_info_token != "") {
          setAuthSteps(6);
        }
      }
    }
  }, [active_modal, redirect_to_admin, new_teaching_info_token]);

  useEffect(() => {
    if (invite_token != "") {
      const apiBaseUrl =
        process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
          ? process.env.NEXT_PUBLIC_API_URL_PROD
          : process.env.NEXT_PUBLIC_API_URL_DEV;

      axios
        .post(
          `${apiBaseUrl}/${
            from === "user_invitation" && from !== ""
              ? "getInvitationDetailsByToken"
              : "getInvitedUserByToken"
          }`,
          {
            invite_token: invite_token,
          }
        )
        .then((result) => {
          if (!result?.data?.error) {
            const invitedMemberDeatils =
              from === "user_invitation" && from !== ""
                ? result?.data?.body
                : result?.data?.data;
            setInvitedMember(invitedMemberDeatils);
            setEmail(invitedMemberDeatils?.email);
            localStorage.setItem(
              "invitedMember",
              JSON.stringify(invitedMemberDeatils)
            );
            setActiveUserType("student");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [invite_token]);

  useEffect(() => {
    if (activeModalForSignUp) {
      handleOpenWelcomeSignUp();
    }
  }, [activeModalForSignUp]);
  //========================= checking user isn't sign or not ================================//

  // Logout menue unauthorized
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMyCourses = (isReservedUrlsForTeacherStudent) => {
    if (isReservedUrlsForTeacherStudent) {
      window.location.replace(`/search`);
    } else {
      window.location.replace(`/my-learning`);
    }
  };

  const handleTeachingPage = () => {
    let teachingAccountList =
      JSON.parse(localStorage.getItem("teachingAccounts")) || [];
    let organizationId = localStorage.getItem("orgId");
    let foundTeachingAccount = teachingAccountList.find(
      (teachingAccount) => teachingAccount?.orgId == organizationId
    );

    if (foundTeachingAccount) {
      process.env.NEXT_PUBLIC_PROJECT_ENV == "prod"
        ? window.open(
            `https://mytakbir.com/t/${foundTeachingAccount?.subDomain}`,
            "_blank"
          )
        : window.open(
            `${window.location.origin}/t/${foundTeachingAccount?.subDomain}`,
            "_blank"
          );
    }
  };

  const completeProfileHandler = () => {
    redirectToPortal("&editProfile=true");
  };

  const redirectToPortal = (path) => {
    // redirect to portal sign in page
    const portalUrl =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_PORTAL_URL_PROD
        : process.env.NEXT_PUBLIC_PORTAL_URL_DEV;
    const userToken = localStorage.getItem("userToken");
    let user = getUserData();
    const tokenData = {
      email: user.email,
      phone_number: user.phone_number,
      userToken: userToken,
    };
    var token = CryptoJS.AES.encrypt(
      JSON.stringify([tokenData]),
      "login-854256-secret-key"
    ).toString();
    console.log(token);
    // var bytes  = CryptoJS.AES.decrypt(token, 'login-854256-secret-key');
    // var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    // console.log(decryptedData);
    if (typeof window !== "undefined") {
      window.location.replace(
        `${portalUrl}/token-based-signin?token=${token}${path}`
      );
    }
  };

  const resendEmailHandler = () => {
    console.log("hi");
    // const apiBaseUrl = process.env.NEXT_PUBLIC_PROJECT_ENV === 'prod' ? process.env.NEXT_PUBLIC_API_URL_PROD : process.env.NEXT_PUBLIC_API_URL_DEV;
    // const postData = {firstName: "", email: "", orgWebsite: ""};
    // axios.post(`${apiBaseUrl}/resendUserEmailVerification`, postData)
    // .then(response => showEmailVerifyMessage(response))
    // .catch((err) => {
    //   console.log(err);
    //   if (err.response.data.message) {
    //     showSnackbarMessage("error", err.response.data.message);
    //   }
    // });
  };

  // ====== Header Scroll Start ======//
  const [sticky, setSticky] = useState({ isSticky: false, offset: 0 });
  const headerRef = useRef(null);

  // handle scroll event
  const handleScroll = (elTopOffset, elHeight) => {
    if (window.pageYOffset > elTopOffset + elHeight) {
      setSticky({ isSticky: true, offset: elHeight });
    } else {
      setSticky({ isSticky: false, offset: 0 });
    }
  };

  const processScroll = () => {
    var header = headerRef.current.getBoundingClientRect();
    const handleScrollEvent = () => {
      handleScroll(header.top, header.height);
    };

    window.addEventListener("scroll", handleScrollEvent);

    return () => {
      window.removeEventListener("scroll", handleScrollEvent);
    };
  };

  // ====== Header Scroll End ======//

  // ====== Search Show hide ======//
  const [isActive, setActive] = useState("false");

  const handleToggle = () => {
    setActive(!isActive);
  };
  // ====== Search Show hide ======//

  // do searching
  const doSearching = () => {
    setActive("false");
    router.push(`/search?q=${searchBoxText}`);
  };

  // ====== Welcome Sign in Modal ======//
  const [openWelcomeSignin, setOpenWelcomeSignin] = React.useState(false);
  const handleOpenWelcomeSignin = () => {
    setOpenWelcomeSignin(true);
  };
  const handleCloseWelcomeSignin = () => setOpenWelcomeSignin(false);
  // ====== Welcome Sign in Modal ======//

  // ====== Welcome Sign Up Modal ======//
  const [openWelcomeSignUp, setOpenWelcomeSignUp] = React.useState(false);
  const handleOpenWelcomeSignUp = () => {
    setOpenWelcomeSignUp(true);
  };
  const handleCloseWelcomeSignUp = () => setOpenWelcomeSignUp(false);
  // ====== Welcome Sign Up Modal ======//

  // ====== Payment Drawer Start======//
  const [openShoppingDrawer, setOpenShoppingDrawer] = useState(false);
  const handleOpenShoppingDrawer = () => {
    setOpenShoppingDrawer(true);
  };
  const CloseShoppingDrawer = () => {
    setOpenShoppingDrawer(false);
  };
  // ====== Payment Drawer End======//

  const handleOnclickPhoneSignIn = () => {
    setSignInWith("phone_number");
    handleOpenSignIn(true);
  };

  const handleOnclickEmailSignIn = () => {
    setSignInWith("email");
    handleOpenSignIn(true);
  };

  const handleOnclickPhoneSignUp = () => {
    setSignUpWith("phone_number");
    handleOpenSignUp(true);
  };

  const handleOnclickEmailSignUp = () => {
    setSignUpWith("email");
    handleOpenSignUp(true);
  };

  // * === menu close on outside click === * //
  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  const showToastWithMessage = (message) => {
    toast.success(message);
  };

  const signInUpHandler = () => {
    setSignInWith("email");
    setAuthState(true);
  };

  const initializeAgain = () => {
    setUserAuthenticated(localStorage.getItem("userAuthenticated"));
    setUserData(JSON.parse(localStorage.getItem("userData")));
    setAnchorEl(false);
    prcoessActiveUserTypeAndOrgId();
    processExpireCoursesAndOrgRelatedToReferral();
    getAlreadyEnrolledCoursesAndNecessaryData();
    processCheckTokenValidationAndProfileCompleted();
    processScroll();
  };

  const signInButtonClickHandler = () => {
    setAuthState(true);
    setSignInWith("email");
  };

  useEffect(() => {
    const stored = localStorage.getItem("activeCurrency");

    if (stored === "USD" || stored === "GBP" || stored === "EUR") {
      dispatch(setActiveCurrency(stored));
    }
  }, [dispatch]);

  return (
    <>
      {/* HelpScout Beacon Loader */}
      <Script id="beacon-loader" strategy="afterInteractive">
        {`
          !function(e,t,n){
            function a(){
              var e=t.getElementsByTagName("script")[0],
              n=t.createElement("script");
              n.type="text/javascript",
              n.async=!0,
              n.src="https://beacon-v2.helpscout.net",
              e.parentNode.insertBefore(n,e)
            }
            if(e.Beacon=n=function(t,n,a){
              e.Beacon.readyQueue.push({method:t,options:n,data:a})
            },
            n.readyQueue=[],"complete"===t.readyState) return a();
            e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)
          }(window,document,window.Beacon||function(){});
        `}
      </Script>

      {/* HelpScout Init Call */}
      <Script id="beacon-init" strategy="afterInteractive">
        {`window.Beacon('init', '71b9d402-f145-4515-9cf4-a91ca5a09a71');`}
      </Script>

      <div className={styles.Header} style={{ marginTop: sticky.offset }}>
        {/* <RunningCourseAlertMessage portal={activeUserType == "teacher" ? "org" : "student"} /> */}
        <div
          id="sticky-header"
          className={`navbar${sticky.isSticky ? " sticky" : ""}`}
          ref={headerRef}
        >
          {/* {profileCompleted == false && (
            <AlrtMessageFullWidth
              message="Add missing information to your profile"
              width="60%"
              icon={<PersonRoundedIcon />}
              //ButtonLable={alertBtnLabel}
              onClick={completeProfileHandler}
              background="#004FE0"
              ButtonColor="#0D3FB3"
              ButtonStatus={true}
              ButtonLable="Complete Profile"
              duration="8000000"
            />
          )} */}

          {/* {userAuthenticated &&  !userVerified && 
              <RedAlrtMessage 
                message={alertText}
                width="60%"
                icon={<ReportProblemRoundedIcon />}
                ButtonLable={alertBtnLabel}
                onClick={resendEmailHandler}
              />} */}

          <div className={styles.MobileHeader}>
            <div className={styles.MobileHeaderC}>
              <div className={styles.MobileHeaderBrand}>
                <Button
                  className={styles.mobileNavIcon}
                  onClick={() => setShow(!show)}
                >
                  <MenuRoundedIcon />
                </Button>

                <div className={styles.HeaderLeft}>
                  <a href="/">
                    <img
                      className={styles.OrgLogo}
                      src="https://cdn.mytakbir.com/static-assets/logos/takbir-lms-learning-management-system-muslim-logo-3x.png"
                      width={285}
                      height={100}
                    />
                  </a>
                  {/* <span></span> */}
                  {/* <a href="/" className={styles.DcLogoMobile}><p>powered by</p><Image className={styles.DcLogo} src={DcLogo} /></a> */}
                  {/* <a href="/" className={styles.DcLogoMobile}><img className={styles.DcLogo} src="https://cdn.mytakbir.com/static-assets/logos/takbir-lms-learning-management-system-muslim-logo-4x.png" /></a> */}
                </div>
              </div>

              <div className={styles.MobileHeaderRight}>
                <div className={styles.ShoppingNotification}>
                  <Buttons
                    icon={<Image src={ShopingBadge} />}
                    IconSpace="0"
                    buttonColor="#fff"
                    color="#004FE0"
                    height="60px"
                    fontSize="20px"
                    border="#E8EAED 1px solid"
                    Notification={cartItems?.length}
                    NotificationStatus={cartItems?.length > 0 ? true : false}
                    onClick={handleOpenShoppingDrawer}
                  />
                </div>

                {/* === Searh Button */}
                {/* <Buttons
                  buttonColor="#fff"
                  color="#D2D3D8"
                  height="40px"
                  width="40px"
                  fontSize="14px"
                  border="#E4E8EC 1px solid"
                  onClick={() => handleToggle(true)}
                  iconafter={<SearchIcon />}
                /> */}

                <div className={styles.ShoppingNotification}>
                  {/* <Buttons
                    icon={<Image src={ShopingBadge} />}
                    buttonColor="#fff"
                    color="#004FE0"
                    height="60px"
                    fontSize="20px"
                    border="#E4E8EC 1px solid"
                    link="/shopping"
                    Notification={cartCourse?.length}
                    NotificationStatus={true}
                  /> */}
                </div>
              </div>
            </div>

            {show ? (
              <div className={styles.ButtonGroupContainer}>
                <div className={styles.ButtonGroup}>
                  <div className="ButtonMobileview" ref={ref}>
                    <div onClick={() => setShow(!show)}>
                      {userAuthenticated == "true" ? (
                        <>
                          <div className={styles.MenuCloseButton}>
                            <Button className={styles.MenuCloseIcon}>
                              <ClearRoundedIcon />
                            </Button>
                          </div>
                          <div className="ProfileSection ProfileSectionMobile">
                            {/* <Avatar variant="rounded" alt="Remy Sharp" src="/static/images/avatar/1.jpg" /> */}
                            {/* <Avatar onClick={handleClick}>{userData ? Array.from(userData?.firstName)[0] : ""}</Avatar> */}
                            {userData?.image ? (
                              <Avatar
                                onClick={handleClick}
                                sx={{ width: 96, height: 96 }}
                                src={userData.image ? userData.image : ""}
                                alt="Avatar"
                              ></Avatar>
                            ) : (
                              <Avatar
                                onClick={handleClick}
                                sx={{ width: 96, height: 96 }}
                                alt="Avatar"
                              >
                                {" "}
                                {userData.firstName
                                  ? Array.from(userData.firstName)[0]
                                  : ""}{" "}
                              </Avatar>
                            )}
                            <div>
                              <h1>
                                {userData?.firstName} {userData?.lastName}
                              </h1>
                              <p>
                                <a href="#">
                                  {truncateText(userData?.email, 25)}
                                </a>
                              </p>
                            </div>
                          </div>
                          <Buttons
                            label={
                              !isReservedUrlsForTeacherStudent
                                ? "My Courses"
                                : "Browse Courses"
                            }
                            buttonColor="#fff"
                            color="#004FE0"
                            height="60px"
                            fontSize="20px"
                            border="#E8EAED 1px solid"
                            onClick={() =>
                              handleMyCourses(isReservedUrlsForTeacherStudent)
                            }
                          />

                          <Buttons
                            label="Log Out"
                            buttonColor="#fff"
                            color="#000"
                            height="60px"
                            fontSize="20px"
                            border="#E8EAED 1px solid"
                            onClick={logoutHandler}
                          />
                        </>
                      ) : (
                        // <>
                        //   <div onClick={() => handleCloseSignUp()}>
                        //     <Buttons
                        //       label="Sign In"
                        //       buttonColor="#fff"
                        //       color="#004FE0"
                        //       height="60px"
                        //       fontSize="20px"
                        //       border="#E4E8EC 1px solid"
                        //       onClick={() => handleOpenWelcomeSignin(true)}
                        //     />
                        //   </div>
                        //   <div onClick={() => handleCloseSignIn()}>
                        //     <Buttons
                        //       label="Join for Free"
                        //       buttonColor="#004FE0"
                        //       color="#fff"
                        //       height="60px"
                        //       fontSize="20px"
                        //       onClick={() => handleOpenWelcomeSignUp(true)}
                        //     />
                        //   </div>{" "}
                        // </>
                        <>
                          <div onClick={() => handleCloseSignUp()}>
                            <Buttons
                              label="Sign In"
                              buttonColor="#fff"
                              color="#004FE0"
                              height="60px"
                              fontSize="20px"
                              border="#E8EAED 1px solid"
                              onClick={() => signInButtonClickHandler()}
                              // onClick={() => handleOpenWelcomeSignin(true)}
                            />
                          </div>

                          <div onClick={() => handleCloseSignIn()}>
                            <Buttons
                              label="Join for Free"
                              buttonColor="#004FE0"
                              color="#fff"
                              height="60px"
                              fontSize="20px"
                              onClick={() => signInButtonClickHandler()}
                              // onClick={() => handleOpenWelcomeSignUp()}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>

          <div className={`${styles.HeaderContainer} ${styles.DekstopHeader}`}>
            <div className={styles.HeaderLeft}>
              <a href="/">
                <img
                  className={styles.OrgLogo}
                  src="https://cdn.mytakbir.com/static-assets/logos/takbir-lms-learning-management-system-muslim-logo-3x.png"
                  width={285}
                  height={100}
                />
              </a>
              {/* <span></span> */}
              {/* <a href="/" className={styles.DcLogoMobile}><p>powered by</p><Image className={styles.DcLogo} src={DcLogo} /></a> */}
              {/* <a href="/" className={styles.DcLogoMobile}><img className={styles.DcLogo} src="https://cdn.mytakbir.com/static-assets/logos/takbir-lms-learning-management-system-muslim-logo-4x.png" /></a> */}
            </div>

            <div className={styles.HeaderRight}>
              <div className="ButtonGroup">
                {/* === Searh Button */}
                {!isReservedUrlsForTeacherStudent &&
                  !teacherSpecialUrl.includes(pathSegment) && (
                    <div className={styles.ButtonGroup}>
                      <Buttons
                        label="Search"
                        buttonColor="#fff"
                        color="#BBBFC9"
                        height="60px"
                        fontSize="20px"
                        border="#E8EAED 1px solid"
                        onClick={() => handleToggle(true)}
                        iconafter={
                          <SearchIcon
                            style={{ color: "#004FE0", marginLeft: "16px" }}
                          />
                        }
                      />
                    </div>
                  )}

                {/* <div className={styles.ShoppingNotification}>
                  <Buttons
                    icon={<Image src={ShopingBadge} />}
                    buttonColor="#fff"
                    color="#004FE0"
                    height="60px"
                    fontSize="20px"
                    border="#E4E8EC 1px solid"
                    link="/shopping"
                    Notification={cartCourse?.length}
                    NotificationStatus={true}
                  />
                </div> */}

                {/*=== Payment Drawer Buton ===*/}
                {!isReservedUrlsForTeacherStudent &&
                  !teacherSpecialUrl.includes(pathSegment) && (
                    <div className={styles.ShoppingNotification}>
                      <Buttons
                        icon={<Image src={ShopingBadge} />}
                        IconSpace="0"
                        buttonColor="#fff"
                        color="#004FE0"
                        height="60px"
                        fontSize="20px"
                        border="#E4E8EC 1px solid"
                        Notification={cartItems?.length}
                        NotificationStatus={
                          cartItems?.length > 0 ? true : false
                        }
                        onClick={handleOpenShoppingDrawer}
                      />
                    </div>
                  )}

                {userAuthenticated == "true" ? (
                  <>
                    {!isReservedUrlsForTeacherStudent && (
                      <Buttons
                        label="Dashboard"
                        buttonColor="#fff"
                        color="#004FE0"
                        height="60px"
                        fontSize="20px"
                        border="#E4E8EC 1px solid"
                        link={
                          activeUserType == "teacher"
                            ? "/teaching-home"
                            : "/learner-home"
                        }
                      />
                    )}
                    {!isReservedUrlsForTeacherStudent && (
                      <>
                        {activeUserType == "teacher" ? (
                          showButton ? (
                            <Buttons
                              label="Teaching Page"
                              buttonColor="#fff"
                              color="#004FE0"
                              height="60px"
                              fontSize="20px"
                              border="#E4E8EC 1px solid"
                              onClick={() => handleTeachingPage()}
                            />
                          ) : (
                            ""
                          )
                        ) : (
                          <Buttons
                            label={
                              !isReservedUrlsForTeacherStudent
                                ? "My Courses"
                                : "Browse Courses"
                            }
                            buttonColor="#fff"
                            color="#004FE0"
                            height="60px"
                            fontSize="20px"
                            border="#E4E8EC 1px solid"
                            onClick={() =>
                              handleMyCourses(isReservedUrlsForTeacherStudent)
                            }
                          />
                        )}
                      </>
                    )}

                    {/*=== Payment Drawer Buton ===*/}
                    {/* <div className={styles.ShoppingNotification}>
                      <Buttons
                        icon={<Image src={ShopingBadge} />}
                        buttonColor="#fff"
                        color="#004FE0"
                        height="60px"
                        fontSize="20px"
                        border="#E4E8EC 1px solid"
                        Notification={cartItems?.length}
                        NotificationStatus={true}
                        onClick={handleOpenShoppingDrawer}
                      />
                    </div> */}

                    <Stack
                      direction="row"
                      spacing={2}
                      className="HeaderUserAvatar"
                    >
                      {/* <Avatar
                    alt="Remy Sharp"
                    src={userIcon}
                    variant="rounded"
                    onClick={handleClick}
                  /> */}
                      {/* <Avatar onClick={handleClick}>{userData ? Array.from(userData?.firstName)[0] : ""}</Avatar> */}
                      {userData?.image ? (
                        <Avatar
                          onClick={handleClick}
                          sx={{ width: 96, height: 96 }}
                          src={userData.image ? userData.image : ""}
                          alt="Avatar"
                        ></Avatar>
                      ) : (
                        <Avatar
                          onClick={handleClick}
                          sx={{ width: 96, height: 96 }}
                          alt="Avatar"
                        >
                          {" "}
                          {userData?.firstName
                            ? Array.from(userData.firstName)[0]
                            : ""}{" "}
                        </Avatar>
                      )}
                    </Stack>

                    <div className="">
                      <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        // className="DropdownMenu"
                        style={{ marginTop: "63px" }}
                      >
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            router.push("/settings");
                          }}
                        >
                          <div className="ProfileSection">
                            {userData?.image ? (
                              <Avatar
                                onClick={handleClick}
                                sx={{ width: 96, height: 96 }}
                                src={userData.image ? userData.image : ""}
                              ></Avatar>
                            ) : (
                              <Avatar
                                onClick={handleClick}
                                sx={{ width: 96, height: 96 }}
                              >
                                {" "}
                                {userData?.firstName
                                  ? Array.from(userData.firstName)[0]
                                  : ""}{" "}
                              </Avatar>
                            )}
                            <div>
                              <h1>
                                {userData?.firstName} {userData?.lastName}
                              </h1>
                              <p>
                                <a href="/settings">
                                  {userData?.email
                                    ? truncateText(userData?.email, 25)
                                    : ""}
                                </a>
                              </p>
                            </div>
                          </div>
                        </MenuItem>

                        <div className={styles.HeaderProfileMenuList}>
                          <div className={styles.divider}></div>

                          {activeUserType === "teacher" ? (
                            <Link
                              href="/my-learning"
                              onClick={() => {
                                localStorage.removeItem("orgId");
                                localStorage.removeItem(
                                  "selectedTeachingAccount"
                                );
                                handleClose();
                              }}
                              style={{
                                textDecoration: "none",
                                textDecorationLine: "none",
                              }}
                            >
                              <MenuBookRoundedIcon /> Learning
                            </Link>
                          ) : (
                            <>
                              <Link
                                href="/learner-home"
                                onClick={handleClose}
                                style={{
                                  textDecoration: "none",
                                  textDecorationLine: "none",
                                }}
                              >
                                <HomeRoundedIcon /> Home
                              </Link>
                              <Link
                                href="/inbox-student"
                                onClick={handleClose}
                                style={{
                                  textDecoration: "none",
                                  textDecorationLine: "none",
                                }}
                              >
                                <QuestionAnswerRoundedIcon /> Inbox
                              </Link>
                              <div className={styles.divider}></div>
                              <Link
                                href="/my-learning"
                                onClick={handleClose}
                                style={{
                                  textDecoration: "none",
                                  textDecorationLine: "none",
                                }}
                              >
                                <MenuBookRoundedIcon /> Learning
                              </Link>
                              <Link
                                href="/certificates"
                                onClick={handleClose}
                                style={{
                                  textDecoration: "none",
                                  textDecorationLine: "none",
                                }}
                              >
                                <EmojiEventsRoundedIcon /> Certificates
                              </Link>
                              <div className={styles.divider}></div>
                              <div className={styles.divider}></div>
                              <Link
                                href="/settings"
                                onClick={handleClose}
                                style={{ textDecoration: "none" }}
                              >
                                <SettingsRoundedIcon /> Settings
                              </Link>
                            </>
                          )}
                          <a onClick={logoutHandler}>
                            <LogoutIcon /> Log Out
                          </a>
                        </div>
                      </Menu>
                    </div>
                  </>
                ) : (
                  <>
                    <div onClick={() => handleCloseSignUp()}>
                      <Buttons
                        label="Sign In"
                        buttonColor="#fff"
                        color="#004FE0"
                        height="60px"
                        fontSize="20px"
                        border="#004FE0 1px solid"
                        onClick={() => signInButtonClickHandler()}
                        // onClick={() => handleOpenWelcomeSignin(true)}
                      />
                    </div>

                    <div onClick={() => handleCloseSignIn()}>
                      <Buttons
                        label="Join for Free"
                        buttonColor="#004FE0"
                        color="#fff"
                        height="60px"
                        fontSize="20px"
                        onClick={() => signInButtonClickHandler()}
                        // onClick={() => handleOpenWelcomeSignUp()}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className={isActive ? "UnActive" : "Active"}>
            <div className={styles.HeaderSearchBox}>
              <div className={styles.HeaderSearchBoxCont}>
                {/* <SearchField />  */}

                <input
                  type="text"
                  className={styles.HeaderSearchBoxInput}
                  placeholder={
                    props.searchBoxPlaceholder
                      ? props.searchBoxPlaceholder
                      : "Search for"
                  }
                  value={searchBoxText}
                  onChange={(event) => {
                    setSearchBoxText(event.target.value);
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                      doSearching();
                    }
                  }}
                />

                <div className={styles.HeaderSearchButton}>
                  <Buttons
                    label="Search"
                    buttonColor="#004FE0"
                    color="#fff"
                    height="55px"
                    fontSize="14px"
                    onClick={doSearching}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={isActive ? "UnActive" : "Active"}>
          <div
            className={styles.BackDrop}
            onClick={() => handleToggle(true)}
          ></div>
        </div>

        {/* === Sign In Modal Start */}
        <ModalThree
          open={openSignIn}
          handleClose={handleCloseSignIn}
          width="540px"
          titileColor="#33B651"
          body={
            <div>
              <SignIn
                handleClose={handleCloseSignIn}
                handleOpenWelcomeSignin={handleOpenWelcomeSignin}
                handleOpen={() => handleOpenSignUp()}
                signInWith={signInWith}
                setSignInWith={setSignInWith}
                openWelcomeModal={() => handleOpenWelcomeSignin(true)}
                active_modal={active_modal}
                invite_token={invite_token}
                organization_invitation={organization_invitation}
                invitationFrom={from}
              />
            </div>
          }
        />
        {/* === Sign In Modal End */}

        {/* === Welcome Sign in */}
        <Welcome
          ModalTitle="Sign in"
          open={openWelcomeSignin}
          handleClose={handleCloseWelcomeSignin}
          handleCloseModal={handleCloseWelcomeSignin}
          //onClickFacebook={onClickFacebook}
          //onClickGoogle={onClickGoogle}
          onClickEmail={() => handleOnclickEmailSignIn()}
          onClickPhone={(e) => handleOnclickPhoneSignIn()}
          WithEmail="Sign in with email"
          WithPhone="Sign in with phone"
          AlreadySignLabel="Sign up"
          SignHandleOpen={() => handleOpenSignUp(true)}
          openWelcomeModal={() => handleOpenWelcomeSignin(true)}
        />

        {/* === Welcome Sign Up */}
        <Welcome
          ModalTitle="Sign up"
          open={openWelcomeSignUp}
          handleClose={handleCloseWelcomeSignUp}
          handleCloseModal={handleCloseWelcomeSignUp}
          //onClickFacebook={onClickFacebook}
          //onClickGoogle={onClickGoogle}
          onClickEmail={() => handleOnclickEmailSignUp()}
          onClickPhone={(e) => handleOnclickPhoneSignUp()}
          // onClickEmail={() => handleOpenSignUp(true)}
          WithEmail="Sign up with email"
          WithPhone="Sign up with phone"
          AlreadySignLabel="Sign in"
          SignHandleOpen={() => handleOpenSignIn(true)}
          openWelcomeModal={() => handleOpenWelcomeSignin(true)}
        />
      </div>

      {/* === Shopping Cart Drawer Start*/}
      <SideDrawer
        drawerWidth="744px"
        padding="24px"
        title={`Shopping Cart (${cartItems?.length} Item${
          cartItems?.length > 1 ? "s" : ""
        })`}
        sideOpen="right"
        open={openShoppingDrawer}
        handleDrawerClose={CloseShoppingDrawer}
        Headerbackground="#004FE0"
        HeaderTextColor="#fff"
        body={<ShoppingCart setOpenSignUpModel={signInUpHandler} />}
      />
      {/* === Shopping Cart Drawer End*/}
      {/* // * === Auth Drawers start === * */}
      <CustomDrawer
        open={authState || openSignUpModel}
        anchor="right"
        overlapDrawer={backArrowIcon}
        outSideClick={false}
        headerCloseIcon={authSteps == 3}
        handleClose={() => {
          setAuthSteps(0);
          setAuthState(false);
          setChangingToken("");
          setForgotPasswordMode(false);
          setPhone("");
          setEmail("");
          setOpenSignUpModel(false);
          setWelcomeResetKey((k) => k + 1);
          sessionStorage.removeItem("from_become_a_teacher");
        }}
        drawerTitle={drawerTitle}
        drawerBodyStyles={{ padding: "32px 40px" }}
        handleBackArrowFn={authSteps === 0 ? false : handleBackArrowFn}
        drawerBody={
          <>
            {authSteps === 0 && (
              <WelcomeSection
                key={welcomeResetKey}
                email={email}
                phone={phone}
                setEmail={setEmail}
                setPhone={setPhone}
                invitationFrom={from}
                signInWith={signInWith}
                active_modal={active_modal}
                setAuthSteps={setAuthSteps}
                invite_token={invite_token}
                setSignInWith={setSignInWith}
                welcomeButtonFn={() => setAuthSteps(1)}
                setPhoneFormatted={setPhoneFormatted}
                showToastWithMessage={showToastWithMessage}
              />
            )}
            {authSteps === 1 && (
              <Password
                email={email}
                phone={phone}
                invitationFrom={from}
                signInWith={signInWith}
                active_modal={active_modal}
                setAuthSteps={setAuthSteps}
                invite_token={invite_token}
                initializeAgain={initializeAgain}
                invited_as_teacher={invited_as_teacher}
                handleSubmitFn={() => setAuthSteps(2)}
                enrollNowHandler={enrollNowHandler}
                enrollNowTrackTermHandler={enrollNowTrackTermHandler}
              />
            )}
            {authSteps === 2 && (
              <ConfirmationOTP
                email={email}
                phone={phone}
                password={password}
                invitationFrom={from}
                signInWith={signInWith}
                active_modal={active_modal}
                invite_token={invite_token}
                setAuthSteps={setAuthSteps}
                setAuthState={setAuthState}
                changingToken={changingToken}
                phoneFormatted={phoneFormatted}
                initializeAgain={initializeAgain}
                setChangingToken={setChangingToken}
                handleSubmitFn={() => setAuthSteps(3)}
                forgotPasswordMode={forgotPasswordMode}
                showToastWithMessage={showToastWithMessage}
                setForgotPasswordMode={setForgotPasswordMode}
              />
            )}
            {authSteps === 3 && (
              <Profile
                email={email}
                phone={phone}
                userData={userData}
                countries={countries}
                timezones={timezones}
                invitationFrom={from}
                signInWith={signInWith}
                active_modal={active_modal}
                invite_token={invite_token}
                setAuthSteps={setAuthSteps}
                setAuthState={setAuthState}
                invitedMember={invitedMember}
                initializeAgain={initializeAgain}
                enrollNowHandler={enrollNowHandler}
                setInvitedMember={setInvitedMember}
                highestEducations={highestEducations}
                freshNewAccountMember={freshNewAccountMember}
              />
            )}
            {authSteps === 4 && (
              <ConfirmPassword
                email={email}
                phone={phone}
                invitationFrom={from}
                signInWith={signInWith}
                active_modal={active_modal}
                setAuthSteps={setAuthSteps}
                invite_token={invite_token}
                changingToken={changingToken}
                showToastWithMessage={showToastWithMessage}

                // handleConfirmPasswordFn={() => setAuthSteps(2)}
              />
            )}
            {authSteps === 5 && (
              <ForgotPassword
                email={email}
                phone={phone}
                setEmail={setEmail}
                setPhone={setPhone}
                password={password}
                signInWith={signInWith}
                setAuthSteps={setAuthSteps}
                setAuthState={setAuthState}
                forgotPasswordMode={forgotPasswordMode}
                showToastWithMessage={showToastWithMessage}
                setForgotPasswordMode={setForgotPasswordMode}
              />
            )}
            {authSteps === 6 && (
              <CreatePassword
                email={email}
                phone={phone}
                password={password}
                invitationFrom={from}
                signInWith={signInWith}
                active_modal={active_modal}
                setAuthSteps={setAuthSteps}
                setAuthState={setAuthState}
                invite_token={invite_token}
                initializeAgain={initializeAgain}
                setPasswordToParent={setPassword}
                showToastWithMessage={showToastWithMessage}
                new_teaching_info_token={new_teaching_info_token}
              />
            )}
          </>
        }
      />
      {/* // * ===  Auth Drawers end  === * */}
      <ToastContainer className="ToastContainer" />
      <SimpleBackdrop open={openBackdrop} handleClose={handleCloseBackdrop} />

      {/*== Push Notification Modal Start ==*/}
      <NotificationComponent
        message={notificationMessage}
        showNotification={showNotification}
        setShowNotification={setShowNotification}
      />
      {/*== Push Notification Modal Start ==*/}
    </>
  );
}

export default Header;
